import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box, Stepper, Step, StepLabel } from "@mui/material";
import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { GlobalState } from "context/GlobalContext";

const JobDetailsDialog = ({ open, onClose, jobId }) => {
	const [job, setJob] = useState(null);
	const { setSnackBar, snackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();

	const handleDownload = async (file_name) => {
		try {
			// file_name = `gs://${file_name}`;
			const res = await axios.post(`/api/shipping_partner_reco/get_file_logs/download`, {
				file_name,
			});

			const { downloadUrl } = res.data;
			console.log("result_file_url:", job.result_file_url, downloadUrl);

			// Redirect browser to signed URL
			window.location.href = downloadUrl;
		} catch (err) {
			console.error("Download error:", err);
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, message: "Failed to download file", severity: "error" });
		}
	};
	// Fetch job details from backend
	const fetchJobDetails = useCallback(async () => {
		if (!jobId) return;
		try {
			const res = await axios.get(`/api/shipping_partner_reco/get_job_by_id/${jobId}`);
			setJob(res.data);
		} catch (err) {
			console.error("Error fetching job details:", err);
		}
	}, [jobId]);

	// Fetch immediately when dialog opens
	useEffect(() => {
		if (open) {
			fetchJobDetails();
		} else {
			setJob(null); // clear when closed
		}
	}, [open, fetchJobDetails]);

	if (!job) return null;

	// Convert "final" → last step
	const progress = job.progress
		.map((p) => ({
			...p,
			step: p.step === "final" ? job.progress.length - 1 : p.step,
		}))
		.sort((a, b) => a.step - b.step);

	const activeStep = progress.length - 1;

	return (
		<Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth keepMounted={false}>
			<DialogTitle>Job Details</DialogTitle>

			<DialogContent dividers>
				<Typography variant="subtitle1">
					<strong>Job ID:</strong> {job.id}
				</Typography>
				<Typography variant="subtitle1">
					<strong>Month:</strong> {job.month}
				</Typography>
				<Typography variant="subtitle1">
					<strong>Year:</strong> {job.year}
				</Typography>
				<Typography variant="subtitle1">
					<strong>Shipping Partner:</strong> {job.shipping_partner}
				</Typography>
				<Typography variant="subtitle1">
					<strong>Created By:</strong> {job.created_by}
				</Typography>
				<Typography variant="subtitle1">
					<strong>Status:</strong> {job.status ? "Completed" : "In Progress"}
				</Typography>

				<Box mt={3}>
					<Typography variant="h6" gutterBottom>
						Progress
					</Typography>

					<Stepper activeStep={activeStep} orientation="vertical">
						{progress.map((stepObj, index) => (
							<Step key={index}>
								<StepLabel />
								<Typography variant="body1">{stepObj.message}</Typography>
								<Typography variant="caption" color="text.secondary">
									{stepObj.timestamp}
								</Typography>
							</Step>
						))}
					</Stepper>
				</Box>

				{job.result_file_url && (
					<Box mt={3}>
						<Button
							variant="contained"
							onClick={() => handleDownload(job.result_file_url)}
							target="_blank"
							rel="noopener noreferrer">
							Download Result File
						</Button>
					</Box>
				)}
			</DialogContent>

			<DialogActions>
				{/* Refresh button */}
				<Button onClick={fetchJobDetails} variant="contained" color="primary">
					Refresh
				</Button>

				<Button onClick={onClose} variant="outlined">
					Close
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default JobDetailsDialog;
